"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSentUpdateInputSchema = exports.projectUpdateSchema = void 0;
const zod_1 = require("zod");
const chat_1 = require("./chat");
exports.projectUpdateSchema = zod_1.z.object({
    id: zod_1.z.string(),
    projectId: zod_1.z.string(),
    chatId: zod_1.z.string(),
    scope: chat_1.statusUpdateScopeSchema,
    content: zod_1.z.string(),
    title: zod_1.z.string(),
    sentAt: zod_1.z.string(),
});
exports.createSentUpdateInputSchema = zod_1.z.object({
    chatId: zod_1.z.string(),
    scope: chat_1.statusUpdateScopeSchema,
    content: zod_1.z.string(),
});
